var _defs, _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#26547c;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.05,
    y: 21.02,
    width: 27.9,
    height: 4.14,
    rx: 2.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.05,
    y: 30.43,
    width: 27.9,
    height: 4.14,
    rx: 2.07
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.05,
    y: 39.84,
    width: 27.9,
    height: 4.14,
    rx: 2.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,58.82A26.32,26.32,0,1,1,60.32,32.5,26.34,26.34,0,0,1,34,58.82ZM34,9.31A23.19,23.19,0,1,0,57.19,32.5,23.21,23.21,0,0,0,34,9.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHamburgerIcon);
export default __webpack_public_path__ + "static/media/BlueHamburgerIcon.76c2a5611783748c9bbec041308ecf46.svg";
export { ForwardRef as ReactComponent };